import { ExpandTableCell } from "./ExpandTableCell";
import { HeadingTableCell } from "./HeadingTableCell";
import { TableCellProps } from "./TableCellProps";

export class ExpandHeadingTableCell extends HeadingTableCell {
    constructor(props?: Partial<TableCellProps>) {
        super({
            ...props,
            fixedWidth: ExpandTableCell.FIXED_WIDTH,
            id: "columnHeaderExpand"
        });
        this.makeSticky();
    }

    public override get selectableInDesigner(): boolean {
        return false;
    }

    private makeSticky() {
        ExpandTableCell.makeStickyCommon(this);
        this.paddingTop = 0;
        this.paddingBottom = 0;
        // this.backgroundColor = getThemeColor("table.headingRow.backgroundColor");
    }

    protected override isResizable(): boolean {
        return false;
    }

    override isSerialized(): boolean {
        return false;
    }
}
